// import StockistMap from './GpMap/index.js';

const GpMap = (parentNode) => {
	const mapType = parentNode.dataset.maptype;
	const mapRef = parentNode.querySelector("[data-gp-map]");

	if (!mapRef) {
		return false;
	}

	window.addEventListener("load", (event) => {
		if (mapType === 'contact') {
			import('./map-contact.js').then(({ default: MapContact }) => {
				MapContact(mapRef);
			});
		} else if (mapType === 'all_projects') {
			import('./map-projects.js').then(({ default: MapProjects }) => {
				MapProjects(mapRef);
			});
		} else if (mapType === 'selected_projects') {
			import('./map-selected-projects.js').then(({ default: MapSelectedProjects }) => {
				MapSelectedProjects(mapRef);
			});
		}
	});
}

export default GpMap;